import { extendObservable, runInAction } from 'mobx';

import { Logger } from '../../../helpers/Logger';
import { CheckoutController } from '../../../networking/controllers/CheckoutController';

class IndividualCheckoutStoreClass {
  constructor() {
    extendObservable(this, {
      checkout: null,
      loading: false,
      error: false,
    });
  }

  async findCheckout(id) {
    runInAction(() => {
      this.checkout = null;
      this.loading = true;
      this.error = null;
    });
    try {
      const checkout = await CheckoutController.find(id);
      runInAction(() => {
        this.checkout = checkout;
      });
    } catch (error) {
      Logger.warn(error);
      runInAction(() => {
        this.error = true;
      });
    } finally {
      runInAction(() => {
        this.loading = false;
      });
    }
  }
}

const IndividualCheckoutStore = new IndividualCheckoutStoreClass();

export { IndividualCheckoutStore };



// WEBPACK FOOTER //
// ./src/pages/installation-coordination/stores/IndividualCheckoutStore.js